import React from "react";
import { PageHeader } from "./PageHeader";
import YouTube from "react-youtube";

export const ConcertMaximum = props => {
    const opts = {
        height: '390',
        width: '640',
        playerVars: {
            autoplay: 0
        }
    };
  return (
    <React.Fragment>
      <PageHeader title="Widowisko muzyczne &ldquo;Na styku dwóch nieskończoności&rdquo;" />
      <div className="content-wrapper">
        <div className="main-content page-widowisko">
            <h5>Widowisko muzyczne „NA STYKU DWÓCH NIESKOŃCZONOŚCI”<br/>
                z muzyką Józefa Skrzeka oraz narracją filmową Jerzego Grębosza<br/>
                Koncepcja i reżyseria: Adam Maj<br/>
                (Auditorium Maximum UJ, 15.09.2019, godz. 20:00)</h5>
             <YouTube
              containerClassName="movie"
              videoId="OZIIVQgFhgs"
              opts={opts}
              />
              <hr/>
            <div className="opis">
                <h4>Widowisko multimedialne „Na styku dwóch nieskończoności”...</h4>

                <p>... było szczególnym punktem programu Dnia Otwartego <a href="http://www.45zfp.uj.edu.pl/#/">45.
                    Zjazdu Fizyków Polskich</a>. Zostało przygotowane specjalnie dla uświetnienia Zjazdu. Skomponowane
                    na potrzeby widowiska utwory muzyczne miały tam swoje prapremiery.</p>

                <p>To wyreżyserowane przez prof. Adama Maja z IFJ PAN widowisko z elementami edukacyjnymi jest
                    połączeniem muzyki, skomponowanej i wykonanej na fortepianie oraz syntezatorach przez Józefa Skrzeka
                    i innych artystów, z narracją obrazowaną filmami i animacjami w wykonaniu dr. hab. Jerzego Grębosza
                    z IFJ PAN.</p>

                <p className="foto-widowisko"><a href="https://www.ifj.edu.pl/popularyzacja/widowisko-mgs/foto/foto5.jpg">
                    <img src="https://www.ifj.edu.pl/popularyzacja/widowisko-mgs/foto/foto5-s1.jpg"
                                                 alt="Widowisko muzyczne „Na styku dwóch nieskończoności”"
                                                 title="Widowisko muzyczne „Na styku dwóch nieskończoności”"/></a></p>

                <p>Malowana muzyką i obrazem filmowym artystyczna wizja historii Naszego Wszechświata, wiedzie nas od
                    osobliwości tuż przed Wielkim Wybuchem (<em>Bubble Universe</em>), poprzez Wielki Wybuch,
                    wytworzenie pierwiastków wodoru, powstanie gwiazd i lekkich pierwiastków (od helu aż do żelaza) w
                    trakcie nukleosyntezy jądrowej, aż wreszcie wybuchów Supernowych umożliwiających powstanie
                    pierwiastków cięższych od żelaza i rozsiewających wszystkie pierwiastki w bezmiar Wszechświata, co
                    umożliwiło powstanie życia. Do tego faktu nawiązuje kulminacyjny utwór muzyczny – podniosła suita
                    „Children of the Stars”, mówiąca o nas, ludziach, żyjących, jak to sformułował Blaise Pascal, na
                    styku dwu nieskończoności: mikroświatem atomów a makroświatem Wszechświata. Widowisko kończy się
                    wizją możliwego scenariusza końca naszego Wszechświata np. w wyniku Wielkiego Rozerwania (<em>Big
                        Rip</em>) i tego, jaką rolę mogą odegrać wtedy supermasywne czarne dziury; wreszcie wizją
                    możliwości wytworzenia nowej osobliwości (i być może Nowego Wszechświata).</p>

                <p>W widowisku, opartym na scenariuszu przygotowanym przez Adama Maja, Jerzego Grębosza, Bogdana Fornala
                    z IFJ PAN oraz Marka Riley’a z Florida State University, wykorzystano teksty literackie <a
                        href="https://opt-art.net/helikopter/5-2018/krzysztof-niewrzeda-wiersze-kosmiczne/">Krzysztofa
                        Niewrzędy</a> oraz A. Maja i J. Mateja. Oprócz Józefa Skrzeka wystąpili: Jerzy Grębosz jako
                    narrator, Mirosław Muzykant grający na instrumentach perkusyjnych, CzeT Minkus na trąbce
                    elektrycznej, Chór Nowodworski (dyr. Ryszard Źróbek), Ela Skrzek (wokal) oraz Wiktoria i Julia Minda
                    (saksofon i obój).
                </p>

                <h3>Notki biograficzne zespołu popularyzatorskiego MGS (Multimedialny Gwiezdny Spektakl),
                    twórców widowiska</h3>

                <p><strong>Józef Skrzek</strong> - kultowa postać na polskiej scenie muzycznej,
                    multiinstrumentalista, wokalista i kompozytor. Już jako dziecko zaczął lekcje gry na
                    fortepianie, a swoją edukację muzyczną odbywał w najlepszych katowickich szkołach. Śmierć
                    ojca w wypadku w kopalni w 1970 r. spowodowała nagły przełom w jego życiorysie: żeby
                    utrzymać rodzinę przerwał studia na Akademii Muzycznej w Katowicach i rozpoczął działalność
                    estradową w polskim zespole rockowym Breakout, jako pianista i basista.<br/>
                    W 1971 roku założył i prowadził przez wiele lat grupę progresywno-rockową SBB.
                    Początkowo SBB grał z Czesławem Niemenem, koncertując w całej Europie. Od 1973 roku
                    zespół SBB rozpoczął samodzielną karierę jako trio, kreując oryginalny styl łączący
                    progresywny rock z jazzem i muzyką klasyczną, z akcentami słowiańskiego romantyzmu.
                    Jedną z charakterystycznych cech muzyki SBB była wirtuozerska gra Skrzeka na analogowym
                    syntezatorze mini-Moog. Zespól SBB bardzo szybko stał się legendą w Polsce oraz w
                    Czechosłowacji, na Węgrzech, w Skandynawii i w Niemczech (NRD i RFN).<br/>
                    W 1980 r., w szczytowym okresie swojej kariery, zespół SBB został oficjalnie rozwiązany,
                    choć później był reaktywowany wiele razy i okazjonalnie koncertuje do dnia dzisiejszego.
                    W 1980 Józef Skrzek rozpoczął swoją wspaniałą, trwającą do dziś, karierę solową
                    wyrażającą się w bardzo w wielu różnych gatunkach muzycznych, często łącząc różne formy
                    sztuki. Do głównych należą: muzyka filmowa, teatralna, operowa i elektroniczna.
                    Rozpoczął także serię wielkich, plenerowych spektakli muzycznych w niezwykłych
                    miejscach, m.in. w Planetarium Śląskim, w podziemnej zabytkowej kopalni w Tarnowskich
                    Górach, na stoku gór Beskidów, w latarni morskiej w Kołobrzegu, w Barbakanie w Krakowie,
                    na Monte-Martre w Paryżu, czy też w Twierdzy Pietropawłowskiej w Sankt Petersburgu.
                    Szczególnie ważnym nurtem w działalności artystycznej Józefa Skrzeka jest tworzenie
                    muzyki religijnej i wykonywanie jej w kościołach na organach piszczałkowych, często w
                    połączeniu z syntezatorem mini-Moog.<br/>
                    Jeden z pierwszych takich koncertów, w 1982 r., był poświęcony pamięci poległych
                    górników podczas wprowadzenia w Polsce stanu wojennego, a jeden z najważniejszych - w
                    Watykanie w 2003 r. w obecności papieża Jana Pawła II. Listę dokonań artystycznych
                    Józefa Skrzeka z jego solowej kariery można by postarać się podliczyć ilością wydanych
                    albumów muzycznych – było ich około 50. (Więcej informacji -
                    <a href="http://skrzek.com">http://skrzek.com</a>,
                    <a href="https://pl.wikipedia.org/wiki/Józef_Skrzek"> https://pl.wikipedia.org/wiki/Józef_Skrzek </a>  i
                    <a href="https://pl.wikipedia.org/wiki/SBB"> https://pl.wikipedia.org/wiki/SBB</a>)
                </p>

                <p><strong>Jerzy Grębosz</strong> - adiunkt (dr hab.) w Instytucie Fizyki Jądrowej Polskiej
                    Akademii Nauk w Krakowie.<br/>
                    Autor publikacji z zakresu fizyki jądrowej i języka C++. Jego bestsellerowe książki –
                    „Symfonia C++ Standard”, oraz „Pasja C++” stały się podręcznikami na wielu polskich
                    uniwersytetach, a książka „Opus Magnum C++11” została laureatem konkursu „Informatyczna
                    Książka roku 2018”.<br/>
                    Popularyzator nauki – wszechświat wyjaśnia w sposób kreatywny i niekonwencjonalny,
                    między innymi poprzez widowiska artystyczne („Duch Fizyki”, „Klątwa Newtona”), filmy
                    popularnonaukowe (nagradzane na przeglądach i festiwalach filmów naukowych i
                    edukacyjnych, wykorzystywane do nauki w szkołach), czy też autorskie spektakle
                    („Gwiezdny Pył – Największe widowisko Wszechświata”).<br/>
                    Z zamiłowania podróżnik – antropolog. W swoich podróżach na wyspy Oceanii poznaje
                    pierwotne plemiona i udaje mu się wnikać w ich kulturę. (Więcej informacji -
                    <a href="https://ifj.edu.pl/private/grebosz/greb_pol.html">https://ifj.edu.pl/private/grebosz/greb_pol.html</a> )
                </p>

                <p><strong>Adam Maj</strong> - polski fizyk jądrowy, od 2006 r. profesor nauk fizycznych.
                    Prowadzi badania eksperymentalne z zakresu struktury jąder atomowych i mechanizmów reakcji
                    jądrowych. Jego główne zainteresowania naukowe to badanie gorących i szybko obracających się
                    jąder atomowych, struktura jąder egzotycznych oraz nowatorskie układy do detekcji
                    promieniowania gamma. Jest współautorem ok. 300 publikacji naukowych. Przez całą swoją
                    karierę związany z Instytutem Fizyki Jądrowej PAN w Krakowie, w latach 2011-2016 był
                    Zastępcą Dyrektora ds. Naukowych tego instytutu a wcześniej był kierownikiem Oddziału Fizyki
                    Jądrowej i Oddziaływań Silnych. Ponadto pełni funkcję Członka Rady Naukowej IFJ PAN i Rady
                    Naukowej Środowiskowego Laboratorium Ciężkich Jonów Uniwersytetu Warszawskiego. Jest
                    członkiem Komitetu Koordynującego Europejską Fizykę Jądrową (NUPECC), członkiem Academia
                    Europea, a także członkiem wielu innych polskich i zagranicznych specjalistycznych Komitetów
                    Naukowych. Od 2017 roku jest przewodniczącym Sekcji Fizyki Jądrowej PTF. (Więcej informacji
                    - <a
                        href="https://pl.wikipedia.org/wiki/Adam_Maj">https://pl.wikipedia.org/wiki/Adam_Maj</a>)
                </p>

                <p>Wywiad w radiu RFM FM: <a
                    href="https://www.rmf24.pl/nauka/news-fizycy-na-styku-dwoch-nieskonczonosci-z-muzyka-jozefa-skrzek,nId,3201409">Fizycy
                    "Na styku dwóch nieskończoności" z muzyką Józefa Skrzeka</a></p>

                <p>Więcej informacji na stronie: <a
                    href="https://www.ifj.edu.pl/popularyzacja/widowisko-mgs/"><h3>https://www.ifj.edu.pl/popularyzacja/widowisko-mgs</h3></a></p>
            </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ConcertMaximum.propTypes = {};
